module.exports = __webpack_public_path__ + "img/newDetail_zbhl4.261bcd62.png";